export const dlWishlistNbItemsData = (nbOfItems) => {
    window.dataLayer.push({
        wishlist: {
            nbOfItems
        }
    });
};
